module.exports = __webpack_public_path__ + "img/alert-window.85e886d0.svg";